<template>
  <v-container>
    <div class="d-flex justify-end">
      <v-breadcrumbs :items="breadItems" divider=">"></v-breadcrumbs>
    </div>

    <v-row>
      <v-col sm="12" md="4" lg="3">
        <v-card min-height="350px" class="border-radius-10">
          <v-row>
            <v-col cols="12">
              <div class="student-profile">
                <div class="student-profile__avatar">
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-card class="mx-auto" max-width="344">

                        <v-img :src="object.student_profile_pic" class="student-profile__photo"></v-img>
                        <a href="" @click.prevent="changePic">

                          <v-fade-transition>
                            <v-overlay v-if="hover" absolute color="#036358">
                              <!-- <v-btn>See more info</v-btn> -->
                              <i class="fas fa-edit"></i>

                            </v-overlay>
                          </v-fade-transition>
                        </a>
                      </v-card>
                    </template>
                  </v-hover>

                </div>
              </div>

              <div class="student-info">
                <div class="student-info__name">{{ object.std_fname }} {{ object.std_lname }}</div>
                <div class="student-info__email">{{ object.gaurdian_email }}</div>
                <div class="student-info__phone">{{ object.gaurdian_contactno }}</div>
              </div>

              <div class="student-class">
                <div class="student-class__info">
                  <div class="student-class__info-title">Enquiry Date</div>
                  <div class="student-class__info-value">{{ object.creation_time }}</div>
                </div>

                <div class="student-class__info">
                  <v-file-input style="opacity:0" show-size label="Choose File" prepend-icon chips solo
                    @change="imageConvert" ref="fileInput"></v-file-input>
                </div>
              </div>

              <div class="student-subjects">
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col sm="12" md="8" lg="9">
        <v-card min-height="100%" class="border-radius-10" style="padding: 12px;">
          <!-- class="box-style" -->
          <v-row>
            <v-col md="6">
              <div class="tutor-details border-right">
                <h2 class="tutor-details__heading">About Student</h2>
                <v-simple-table class="tutor-details__table" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="item-name">Full Name</th>
                        <td class="item-value text-right">{{ object.std_fname }} {{ object.std_lname }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Username</th>
                        <td class="item-value text-right">{{ object.std_username }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Gender</th>
                        <td class="item-value text-right">{{ object.std_gender }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Tuition Type</th>
                        <td class="item-value text-right">{{ object.std_tuition_type }}
                        </td>
                      </tr>
                      <tr v-if="object.class">
                        <th class="item-name">Year/Class Allocated</th>
                        <td class="item-value text-right">{{ object.class.class_name }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">School Name</th>
                        <td class="item-value text-right">{{ object.std_school_name }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>

            <v-col md="6">
              <div class="tutor-details">
                <h2 class="tutor-details__heading">Guardian Details</h2>
                <v-simple-table class="tutor-details__table" dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="item-name">Guardian Name</th>
                        <td class="item-value text-right">{{ object.gaurdian_fname }} {{ object.gaurdian_lname }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Guardian Email</th>
                        <td class="item-value text-right">{{ object.gaurdian_email }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Guardian Contact No</th>
                        <td class="item-value text-right">{{ object.gaurdian_contactno }}
                        </td>
                      </tr>
                      <tr>
                        <th class="item-name">Address</th>
                        <td class="item-value text-right">{{ object.std_address }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import moment from 'moment';

export default {
  name: "Profile",
  components: {},
  methods: {
    formatDate(date) {
      // console.log(date,'ddddddddddddddddd');
      if(date != undefined){
        // console.log(typeof date,'date type');
        // console.log(date,'date type');
        // console.log(moment('22-07-2022').format("DD-MM-YYYY"),"moment('22-07-2022').format('DD-MM-YYYY')");
        return moment('22-07-2022').format("DD-MM-YYYY")
      }
    },

    getProfile() {
      let user = JSON.parse(localStorage.getItem('user'));
      let da = moment('2022-10-10').format("Do MMM YY")
      // console.log(da,'ddddddddddddddd');
      axios.get(apiRoutes.students.studentpanel.profile + '/' + user.id).then(response => {
        // console.log(response.data)
        this.object = response.data
      })
    },
    changePic() {
      // console.log(this.$refs.fileInput)
      // this.$refs.fileInput.click()
      this.$refs.fileInput.$refs.input.click()
    },
    imageConvert(e) {
      let user = JSON.parse(localStorage.getItem('user'));


      console.log(e)
      var reader = new FileReader()
      reader.readAsDataURL(e)
      reader.onload = () => {
        var data = {
          user_id: user.id,
          image: reader.result
        }


        axios.post("changeStudentPic", data).then((response) => {
          // console.log(response.data)
          this.getProfile()
          // this.countries = response.data.countries;
        });

      }



    },
  },
  data() {
    return {
      show: false,
      object: {},
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard"
          }
        },
        {
          text: "Students",
          disabled: true,
          to: {
            name: "Students"
          }
        },
        {
          text: "Profile",
          disabled: true,
          to: {
            name: "StudentProfile"
          }
        }
      ]
    };
  },
  mounted() {
    this.getProfile()
  }
};
</script>

<style lang="scss" scoped>
.border-radius-10 {
  border-radius: 10px;
}

.student-profile {
  height: 175px;
  margin-top: -12px;
  background: #f1efef;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &__avatar {
    max-height: 120px;
    overflow: hidden;
    width: 120px;
    border-radius: 50%;
    border: 1px solid #6a158e;
    padding: 2px;
    margin-bottom: -20px;
  }
}

.student-info {
  margin-top: 40px;
  text-align: center;

  &__name {
    font: 500 18px/22px Gotham;
    color: #172b4d;
  }

  &__email,
  &__phone {
    font: 400 14px/22px Gotham;
    color: #3f475d99;
  }
}

.student-class {
  padding: 10px 18px;
  margin-top: 30px;
  border: 0.5px solid #d6dbe1;
  border-left: 0;
  border-right: 0;

  &__info {
    display: flex;
    justify-content: space-between;

    &-title {
      font: 500 14px/20px Gotham;
      color: #172b4d;
    }

    &-value {
      font: 300 14px/13px;
      font-family: "Gotham Narrow";
      color: #8898aa;
    }
  }
}

.student-subjects {
  padding: 10px 18px;
  margin-top: 15px;

  &__btn {
    margin-bottom: 10px;
  }
}
</style>